/** @jsxImportSource theme-ui */

import React from 'react';

type BdAspectRatioProps = {
  ratio: number;
};

/**
 * Aspect ratio taken from https://medium.com/bleeding-edge/enforcing-an-aspect-ratio-on-an-html-element-in-react-and-css-27a13241c3d4
 * and converted to using jsx instead of styled-components
 */
const BdAspectRatio: React.FC<BdAspectRatioProps> = ({ ratio, children }) => {
  return (
    <div
      sx={{
        position: 'relative',
        width: '100%',
        height: 0,
        paddingBottom: `${(1 / ratio) * 100}%`,
      }}
    >
      <div sx={{ position: 'absolute', top: 0, right: 0, bottom: 0, left: 0 }}>{children}</div>
    </div>
  );
};

export default BdAspectRatio;
